/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFlare = createReactComponent("outline", "flare", "IconFlare", [["path", { "d": "M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3z", "key": "svg-0" }]]);

export { IconFlare as default };
//# sourceMappingURL=IconFlare.mjs.map
